import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';

import './EmptyInboxPlaceholder.scss';

type EmptyInboxPlaceholderProps = {
    isHovered: boolean;
};

const EmptyInboxPlaceholder = (props: EmptyInboxPlaceholderProps): ReactElement => (
    <div className="EmptyInboxPlaceholder">
        <div className="inbox-placeholder-content">
            <p className="tip">
                A place to put things while you decide
                <br /> where they should go
            </p>
        </div>
    </div>
);

EmptyInboxPlaceholder.propTypes = {
    isHovered: PropTypes.bool,
};

export default EmptyInboxPlaceholder;
